import { EyeOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, Card, Space, Spin, Table, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { errorHandler, tiposAutorizacion } from '../../utils';
import { instanceRef } from '../../utils/axios';

const AutorizacionTipoValidaciones = () => {
  const {
    params: { id: idTipo, tipo: tipoParam }
  } = useRouteMatch();
  const [loading, setLoading] = useState();
  const [tipo, setTipo] = useState();
  const [columns, setColumns] = useState();
  const history = useHistory();

  const setearColumnas = () => {
    setColumns([
      {
        title: 'Tipo',
        dataIndex: 'tipo',
        key: 'tipo'
      },
      {
        title: 'Acciones',
        key: 'action',
        width: '10px',
        align: 'left',
        render: (text, record) => {
          return (
            <Space size="small">
              <Tooltip title="Ver">
                <Button
                  icon={<EyeOutlined />}
                  type="text"
                  size="middle"
                  hidden
                />
              </Tooltip>
              <Tooltip title="Configuración">
                <Button
                  icon={<SettingOutlined />}
                  type="text"
                  size="middle"
                  onClick={() =>
                    handleOpenConfig(
                      `/autorizacion-configuracion/${tipoParam}/${idTipo}/${record.key}`
                    )
                  }
                />
              </Tooltip>
            </Space>
          );
        }
      }
    ]);
  };

  const handleOpenConfig = (url) => {
    history.push(url);
  };

  const getTipo = async () => {
    setLoading(true);
    try {
      let urlTipo = '';
      if (tipoParam === 'aseguradoraProducto') {
        urlTipo = `/aseguradoraproducto/aseguradoraproducto/${idTipo}`;
      } else if (tipoParam === 'aseguradoraEmpresaProducto') {
        urlTipo = `/aseguradoraempresaproducto/${idTipo}`;
      } else if (tipoParam === 'empresaProducto') {
        urlTipo = `/empresaProducto/${idTipo}`;
      }

      if (urlTipo) {
        const response = await instanceRef.instance.get(urlTipo, {});
        const data = response.data?.data;
        if (data) {
          if (tipoParam === 'aseguradoraProducto') {
            const tipoObj = {
              tipo: data.aseguradora.descripcion || '',
              producto: data.producto
            };
            setTipo(tipoObj);
          } else if (tipoParam === 'aseguradoraEmpresaProducto') {
            const tipoObj = {
              tipo:
                ` ${data.aseguradoraEmpresa.aseguradora.descripcion} - ${data.aseguradoraEmpresa.empresa.nombre_corto}` ||
                '',
              producto: data.producto
            };
            setTipo(tipoObj);
          } else if (tipoParam === 'empresaProducto') {
            const tipoObj = {
              tipo: data.empresa.nombre_corto || '',
              producto: data.producto
            };
            setTipo(tipoObj);
          }
        }
      }
      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (tipo) {
      setearColumnas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipo]);

  useEffect(() => {
    getTipo(); // Corresponde a AseguradoraProducto, AseguradoraEmpresaProducto, EmpresaProducto
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ResponsiveContainer size="large">
        <Card
          title={
            tipo &&
            `Configuración de Autorización - ${tipo.tipo} - ${tipo.producto.descripcion}`
          }
          style={{ textAlign: 'left' }}
        >
          <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
            {columns && (
              <Table
                fixed
                scroll={false}
                style={{ maxWidth: '500px', width: '100%' }}
                bordered
                dataSource={tiposAutorizacion}
                columns={columns}
                pagination={false}
                rowKey={(record) => record.key}
                size="small"
                rowClassName={(record) => {
                  return record.key === 'actividad' &&
                    tipo.producto.codigo !== 4 &&
                    tipo.producto.codigo !== 5
                    ? 'hidden'
                    : '';
                }}
              />
            )}
          </Spin>
        </Card>
      </ResponsiveContainer>
    </>
  );
};

export default AutorizacionTipoValidaciones;
